export class OutsourceState {
    static ALL = -1;
    static ACTIVE = 0;
    static INACTIVE = 1;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/OutsourceState.js